/** `/orders/:id` + `{ id: 3 }` → `/orders/3`. 빠진 파라미터가 있으면 던진다. */
export function fillPath(path: string, params: Readonly<Record<string, string | number>> = {}) {
  return path.replace(/:([A-Za-z_][A-Za-z0-9_]*)/g, (_, name: string) => {
    const value = params[name];
    if (value === undefined || value === '') {
      throw new Error(`경로 파라미터 "${name}" 가 없습니다: ${path}`);
    }
    return encodeURIComponent(String(value));
  });
}
